import React from 'react';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';

import { TEXT_COLOR, TEXT_SIZE } from '@components/Text';
import { DeleteActionButton } from '@shared/Resources/Stimulus/shared/tabStyles';
import { POPULATION_OPTIONS } from '../SpeechTopics/config';
import { truncateForTableCell } from '../../shared/textPreview';
import { formatDateTime, formatPopulation, toEpochMillis } from '../../shared/formatters';

export const createSentencesTableConf = ({ onDelete }) => [
  {
    getDisplay: (item) => item.locale || '',
    name: 'Locale',
    textOptions: { withEllipsis: true },
    width: 85,
    sortable: true,
    sortValue: (item) => item.locale || '',
  },
  {
    getDisplay: (item) => truncateForTableCell({ text: item?.text, locale: item?.locale }),
    name: 'Sentence Text',
    textOptions: { size: TEXT_SIZE.H4, color: TEXT_COLOR.DARK_BLUE, withEllipsis: true },
    sortable: true,
    sortValue: (item) => (item.text || '').trim(),
  },
  {
    getDisplay: (item) => item.intonation || '',
    name: 'Intonation',
    textOptions: { withEllipsis: true, align: 'center' },
    width: 140,
    sortable: true,
    sortValue: (item) => item.intonation || '',
  },
  {
    getDisplay: (item) => item.sentenceLength || '',
    name: 'Sentence Length',
    textOptions: { withEllipsis: true, align: 'center' },
    width: 140,
    sortable: true,
    sortValue: (item) => item.sentenceLength || '',
  },
  {
    getDisplay: (item) => (typeof item.wordCount === 'number' ? item.wordCount : ''),
    name: 'Word Count',
    textOptions: { align: 'center' },
    width: 110,
    sortable: true,
    sortValue: (item) => (typeof item.wordCount === 'number' ? item.wordCount : null),
  },
  {
    getDisplay: (item) => (typeof item.syllableCount === 'number' ? item.syllableCount : ''),
    name: 'Syllable Count',
    textOptions: { align: 'center' },
    width: 130,
    sortable: true,
    sortValue: (item) => (typeof item.syllableCount === 'number' ? item.syllableCount : null),
  },
  {
    getDisplay: (item) => formatDateTime(item?.createdAt),
    name: 'Created At',
    textOptions: { withEllipsis: true },
    width: 170,
    sortable: true,
    sortValue: (item) => toEpochMillis(item?.createdAt),
  },
  {
    getDisplay: (item) => formatDateTime(item?.updatedAt),
    name: 'Updated At',
    textOptions: { withEllipsis: true },
    width: 170,
    sortable: true,
    sortValue: (item) => toEpochMillis(item?.updatedAt),
  },
  {
    getDisplay: (item) => formatPopulation(item.population, POPULATION_OPTIONS),
    name: 'Population',
    textOptions: { withEllipsis: true },
    width: 120,
    sortable: true,
    sortValue: (item) => (item.population || []).join(','),
  },
  {
    getDisplay: (item) => (
      <DeleteActionButton
        type="button"
        onClick={(e) => {
          e.stopPropagation();
          onDelete(item.id);
        }}
        title="Delete"
      >
        <DeleteIcon color="error" sx={{ fontSize: 22 }} />
      </DeleteActionButton>
    ),
    name: '',
    width: 40,
  },
];
